<template>
    <div style="background: white">
        <div class="breadBox">
            <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item @click="onRollback" style="cursor:pointer">法律法规</a-breadcrumb-item>
                <a-breadcrumb-item>法律法规详情</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div id="print" class="tabBox">
            <div class="title">{{noticeObj.title}}</div>
            <div class="subtitle">
                <span>来源:{{noticeObj.origin}}</span>
                <span> 发布日期:{{noticeObj.publishTime}}</span>
                <span onselectstart="return false;"> 字体: <span style="cursor: pointer;margin:0" @click="sizes++">【放大】</span><span style="cursor: pointer;margin:0" @click="sizes--">【缩小】</span><span style="cursor: pointer;margin:0" @click="sizes=16">【标准】</span>
                <PrintOn></PrintOn>
            </span>
            </div>
            <div class="titlecontent" :style="{ fontSize: sizes + 'px' }" >{{noticeObj.contentAbstract}}</div>
            <div class="content" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.content"></div>
        </div>
    </div>

</template>
<script>
import {policyWeb} from "@/api/innovationService";

export default {
    name:"noticeDetail",
    components:{},
    data(){
        return{
            sizes:16,
            noticeObj:{}

        }
    },
    methods:{
        getDetail(){
            this.getAction({
                url:policyWeb.getDetail,
                params:{id:this.$route.query.id}
            }).then(res=>{
                this.noticeObj= res
            })
        },
        onRollback(){
            this.$router.push({
                path:"/finance/law",
                query:{
                    type:"法律法规"
                }
            })
        },
        onRollbackHome(){
            this.$router.push({
                path:"/finance/index",
                query:{
                    type:"首页"
                }
            })
        }
    },
    mounted() {
        this.getDetail()
    }
}
</script>
<style lang="less" scoped>
.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}
.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;
    .title{
        text-align: center;
        font-size: 30px;
        color: #333;
    }
    .subtitle{
        font-size: 14px;
        margin-top: 30px;
        padding-bottom: 20px;
        color: #333;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: center;
        span{
            margin: 0 20px;
        }
    }
    .titlecontent{
        text-align: center;
        font-size: 16px;
        margin-top: 60px;
        font-weight: 600;
        padding:0 10%;
        line-height: 40px;
    }
    .content{
        padding:0 10%;
        font-size: 16px;
        line-height: 30px;
        margin-top: 60px;
        text-indent: 30px;
        :deep(img){
            width:60%;
            margin-left: 18%;
            margin-bottom: 20px;
        }
        :deep(p){
            line-height: 40px;
        }
    }
}

</style>
